import React from 'react'

export const Formerror = (props) => {
    return (
        <span style={{color:"red", fontSize:"11px"}}>{props.error ? props.error : <span style={{visibility:"hidden"}}>error</span>}</span>
    )
}
